import { StateProvider } from "@uirouter/angularjs";
import { addRoute as noteRoute } from "./notes/route";
import { addTimelineRoutes } from "./timeline/route";

export function addProcessDetailRoutes(
  $stateProvider: StateProvider,
  baseRoute: string,
) {
  noteRoute($stateProvider, `${baseRoute}.notes`);
  addTimelineRoutes($stateProvider, `${baseRoute}.timeline`);
}
